/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
import {Component, OnInit} from '@angular/core';

declare var $: any;

// import * from 'jquery';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  /**
   * Intitialize the class
   */
  constructor() {
  }

  /**
   * On Init Lifecycle Hook
   */
  ngOnInit() {
  }
}
